import React from 'react'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { vehicleTypes } from '../../../../lib/util'
import FormHelperText from '@mui/material/FormHelperText'
import { styled } from '@mui/material/styles'

const AutocompleteStyled = styled(Autocomplete)({
  [`.MuiInputBase-root`]: {
    padding: '4px',
    paddingRight: '65px',
  },
})

const TextFieldStyled = styled(TextField)({
  [`label`]: {
    color: 'gray !important;',
    fontSize: '14px;',
  },
})

export default function VehicleSelect(props) {
  const selected = vehicleTypes.find(item => item.vehicle === props.value)
  return (
    <>
      <AutocompleteStyled
        //multiple
        id="tags-outlined"
        options={vehicleTypes}
        groupBy={option => option.standard}
        getOptionLabel={option => (option.vehicle ? option.vehicle : option)}
        onChange={props.onChange}
        //value={selected}
        style={{ width: props.width ? props.width : '100%' }}
        renderInput={params => (
          <TextFieldStyled
            {...params}
            margin="dense"
            id="outlined-secondary"
            label="Vehicle Type"
            variant="outlined"
            //placeholder="Vehicle Type"
            fullWidth
          />
        )}
      />
      {/*<FormHelperText id="component-error-text">*/}
      {/*  Click to select one or more*/}
      {/*</FormHelperText>*/}
    </>
  )
}
